import { paths } from "@features/routering/paths";
import { BreadcrumbItem } from "@packages/uiKit/BreadCrumbs/type";

export const breadCrumbsAboutPage: BreadcrumbItem[] = [
  {
    label: "главная",
    link: paths.root()
  },
  {
    label: "продавайте на HalalShop"
  }
];
